/**
 * @param url
 * @returns {string}
 */
export function publicUrl(url) {
  return `${import.meta.env.BASE_URL}${url}`;
}
